import { createSelector } from 'reselect';

export const getComponentState = state => state.shoppingCart;

export const getItems = createSelector(
    getComponentState,
    (state) => state.items
);
export const getFetching = createSelector(
    getComponentState,
    (state) => state.fetching
);
export const getChecking = createSelector(
    getComponentState,
    (state) => state.checking
);
export const getChangingQuantity = createSelector(
    getComponentState,
    (state) => state.changingQuantity
);
export const getChangingQuantityId = createSelector(
    getComponentState,
    (state) => state.changingQuantityId
);
export const getShippingType = createSelector(
    getComponentState,
    (state) => state.shippingType
);
export const getCheckingOut = createSelector(
    getComponentState,
    (state) => state.checkingOut
);
export const getCheckingId = createSelector(
    getComponentState,
    (state) => state.checkingId
);